import styled, { css } from "styled-components/native";
import { StyledProps } from "./model";

export const getBannerWidth = (isNarrow: boolean, isStudioAccess: boolean): number => {
	if (isNarrow) return isStudioAccess ? 220 : 274;
	return 560;
};

export const getLandscapeStyles = ({ isBackUpImage, isNarrow, isStudioAccess }: StyledProps) => {
	if (isBackUpImage) {
		return css`
			width: 180.48px;
			aspect-ratio: ${2 / 3};
		`;
	}

	return css`
		width: ${getBannerWidth(!!isNarrow, !!isStudioAccess)}px;
		aspect-ratio: ${16 / 9};
	`;
};

export const getMarginLeft = (index?: number, isNarrow?: boolean, isStudioAccess?: boolean, isPreview?: boolean): number | undefined => {
	if (index !== 0) return undefined;
	if (isPreview) return isNarrow ? 64 : 97;
	if (isNarrow) return isStudioAccess ? 30 : 110;
	return 151;
};

export const StyledSlider = styled.View<StyledProps>`
	margin-right: ${({ isNarrow }) => (isNarrow ? "1rem" : "1.5rem")};
	position: relative;
	display: flex;
	align-items: flex-start;
	background-color: #2c2c2c;
	border-radius: 16px;
	height: auto;

	/* First slide margin-left */
	margin-left: ${({ index, isNarrow, isStudioAccess, isPreview }) => getMarginLeft(index, isNarrow, isStudioAccess, isPreview)}px;

	/* Studio access bottom spacing */
	${({ isStudioAccess }) =>
		isStudioAccess &&
		css`
			margin-bottom: 88px;
		`}

	/* Landscape styles */
  ${({ isLandscape, ...rest }) => isLandscape && getLandscapeStyles(rest)}

  /* Portrait styles */
  ${({ isLandscape, isNarrow }) =>
		!isLandscape &&
		css`
			width: ${isNarrow ? "131px" : "268px"};
			aspect-ratio: ${2 / 3};
		`}
`;
